<template>
    <div>

        <div class="text-h5 px-4">

        Квитанция 
        </div>

 
        <v-list-item>
            <v-list-item-content>
                           <v-list-item-subtitle>
                    Адрес
                </v-list-item-subtitle>
                <v-list-item-title>
                    пр-кт Ленина д.12 кв.345
                </v-list-item-title>
     
            </v-list-item-content>
        </v-list-item>

        <v-divider class="ml-4"/>

        
        <v-list-item>
            <v-list-item-content>
                              <v-list-item-subtitle>
                    Лицевой счет
                </v-list-item-subtitle>
                <v-list-item-title>
                    100500
                </v-list-item-title>
  
            </v-list-item-content>
        </v-list-item>

        <v-divider class="ml-4"/>

             <v-list-item>
            <v-list-item-content>
                           <v-list-item-subtitle>
                    Период оплаты
                </v-list-item-subtitle>
                <v-list-item-title>
                    Ноябрь 2020
                </v-list-item-title>
     
            </v-list-item-content>
        </v-list-item>

          <v-divider class="ml-4"/>

        <div class="mx-4 mt-3">

        <v-label>Оплатить с помощью:</v-label>

        </div>


        <v-list-item @click.stop>
           <!--  <v-list-item-avatar> -->
                <img src="@/assets/mark_ps_card.png" height="36" class="mr-3"/>
          <!--   </v-list-item-avatar> -->
            <v-list-item-content>
                <v-list-item-title>
                    Visa, Master Card, МИР
                </v-list-item-title>
                <v-list-item-subtitle>
                    Оплата картой
                </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
        </v-list-item>

        <v-list-item @click.stop>
                  <img src="@/assets/mark_ps_sbrf.png" height="36" class="mr-3"/>
            <v-list-item-content>
                <v-list-item-title>
                    Сбербанк Онлайн
                </v-list-item-title>
                <v-list-item-subtitle>
                    Оплата через мобильно приложение
                </v-list-item-subtitle>
            </v-list-item-content>
                  <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
        </v-list-item>

        <v-list-item @click.stop>

                  <img src="@/assets/mark_ps_card.png" height="36" class="mr-3"/>
            <v-list-item-content>
                <v-list-item-title>
                    Google Pay
                </v-list-item-title>
                <v-list-item-subtitle>
                    С помощью какого то сервиса
                </v-list-item-subtitle>
            </v-list-item-content>
                  <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
        </v-list-item>


        <!--       <v-footer app>
          <v-btn color="primary" block>Оплатить</v-btn>
      </v-footer> -->
    </div>
</template>

<script>
    export default {

    }
</script>

<style>

</style>